import Vue from 'vue';

const key = 'simple-music.floating-lyrics.v1';
function preferences() {
  try {
    const value = JSON.parse(localStorage.getItem(key) || '{}');
    return {
      fontSize: Number.isFinite(value.fontSize) ? Math.max(18, Math.min(44, value.fontSize)) : 28,
      translation: value.translation !== false,
      locked: value.locked === true,
      x: Number.isFinite(value.x) ? value.x : 24,
      y: Number.isFinite(value.y) ? value.y : Math.max(90, innerHeight - 360),
    };
  } catch { return { fontSize: 28, translation: true, locked: false, x: 24, y: Math.max(90, innerHeight - 360) }; }
}

// Visibility is session-only. A new system PiP window always requires a click.
export const floatingLyrics = Vue.observable({ ...preferences(), open: false, external: false });
export function saveFloatingLyrics() {
  const { fontSize, translation, locked, x, y } = floatingLyrics;
  try { localStorage.setItem(key, JSON.stringify({ fontSize, translation, locked, x, y })); } catch { /* Audio and dragging remain usable if storage is full. */ }
}
export function toggleFloatingLyrics() { floatingLyrics.open = !floatingLyrics.open; }
